<template>
    <div class="p-3">
        <form class="col-lg-6 form-login" @submit.prevent="changePassword">
            <span @click="$emit('close')" class="close top-right"><i class="fa fa-times" aria-hidden="true"></i></span>
            <h3>{{$t('user.change_password')}}</h3>
            <b-row>
                <span class="span-title float-left"> {{ $t('user.new_password') }}</span>
                <b-form-input v-model="password"
                              class="mt-1"
                              type="password"
                              id="inputPassword"
                              :placeholder="$t('user.new_password')"
                              required
                              autofocus/>
                <span v-if="!isValidPassword(password)"
                      class="note float-left">
                    {{$t('user.too_short') }}</span>
            </b-row>
            <b-row>
                <span class="span-title float-left"> {{ $t('user.confirm_password') }}</span>
                <b-form-input v-model="password2"
                              :disabled="!isValidPassword(password)"
                              class="mt-1"
                              type="password"
                              id="inputPassword"
                              :placeholder="$t('user.confirm_password')"
                              required/>
                <span v-if="password2 && !validatePassword()"
                      class="note float-left">
                    {{$t('user.not_identical') }}</span>
            </b-row>

            <b-row>
                <b-button type="submit"
                          :disabled="!validatePassword()"
                          size="lg"
                          variant="primary col-sm-12 m-0 mt-4 fair-button">
                    <span>{{$t('common.save')}}</span>
                </b-button>
            </b-row>

        </form>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
                @alertDismiss="alertDismiss"
        />
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>

</template>

<script>
    import FairApi from "../../modules/api";
    import Alert from "../Alert";
    import {alertMixin} from "../../mixins/AlertMixin";
    import {userHelper} from "../../mixins/UserMixin";

    export default {
        name: "reset-password",
        mixins: [alertMixin, userHelper],
        components: {Alert},
        data() {
            return {
                loading: false,
                token: "",
                password: null,
                password2: null,
                note: false
            }
        },

        mounted: function () {
            this.token = this.$route.query.token
        },

        methods: {
            validatePassword: function () {
                return this.password === this.password2
            },

            changePassword: function () {
                this.loading = true
                FairApi.put(FairApi.userResetPsw(null), {token: this.token, password: this.password},
                    this.success, this.fail)
            },

            success: function () {
                this.loading = false
                this.note = true
                this.showAlert(this.$t('user.password_update'), "info")
            },

            fail: function () {
                this.loading = false
                this.password = null
                this.password2 = null
                this.showAlert(this.$t('common.alert_update_failed'))
            },

            alertDismiss: function () {
                if (this.note) {
                    // back to main view
                    this.$router.push('/')
                }
            }
        }
    }
</script>

<style scoped>

</style>
